export const bics = {
  "bics": [
    {
    "code": "G425115",
    "desc": "Clothing retailing",
    "keywords": ["clothes", "garment"],
    "definition": "<p>This also includes retailing sportswear, and knitting or clothing crafts.</p>",
    "definitionPlainText": "This also includes retailing sportswear, and knitting or clothing crafts.",
    "important": "",
    "lastUpdateDate": "2016-05-25T21:39:27.238Z",
    "id": "555c7ba77aaceec91e3f2a02",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "55624ea8f0529345d1e61d82",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Retailing second hand clothes only use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2a21",
        "type": "bic",
        "desc": "G427350 Second hand clothing retailing"
      }],
      "id": "55775f502c8535844998d7c1",
      "bicId": "555c7ba77aaceec91e3f2a02",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G425140",
    "desc": "Protective clothing retailing",
    "definition": "<p>This includes retailing safety clothing eg high visibility clothing.</p>",
    "definitionPlainText": "This includes retailing safety clothing eg high visibility clothing.",
    "important": "",
    "lastUpdateDate": "2015-11-03T23:09:29.825Z",
    "id": "555c7ba77aaceec91e3f2a07",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Wholesaling protective clothing use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2954",
        "type": "bic",
        "desc": "F371210 Clothing wholesaling"
      }],
      "id": "55775f8f2c8535844998d7c6",
      "bicId": "555c7ba77aaceec91e3f2a07",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G427350",
    "desc": "Second hand clothing retailing",
    "definition": "<p>This includes retailing second hand clothing.</p>",
    "definitionPlainText": "This includes retailing second hand clothing.",
    "important": "",
    "lastUpdateDate": "2015-11-30T22:09:26.830Z",
    "id": "555c7ba77aaceec91e3f2a21",
    "cuId": "555b1da725a9732ca20a1308",
    "anzsicId": "555b206c25a9732ca20a1018",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1022",
    "cu": {
      "code": "52520",
      "desc": "Antique and used goods retailing",
      "id": "555b1da725a9732ca20a1308"
    },
    "anzsic": {
      "code": "G427300",
      "desc": "Antique and Used Goods Retailing",
      "id": "555b206c25a9732ca20a1018"
    },
    "bicrefs": []
  }, {
    "code": "G425150",
    "desc": "Work clothing retailing",
    "definition": "<p>This includes retailing work uniforms.</p>",
    "definitionPlainText": "This includes retailing work uniforms.",
    "important": "",
    "lastUpdateDate": "2015-11-03T23:10:13.705Z",
    "id": "555c7ba77aaceec91e3f2a09",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Wholesaling work clothing use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2954",
        "type": "bic",
        "desc": "F371210 Clothing wholesaling"
      }],
      "id": "55775fa52c8535844998d7c8",
      "bicId": "555c7ba77aaceec91e3f2a09",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G425110",
    "desc": "Clothing accessory retailing",
    "keywords": [],
    "definition": "<p>This includes retailing clothing accessories eg gloves.</p>",
    "definitionPlainText": "This includes retailing clothing accessories eg gloves.",
    "important": "",
    "lastUpdateDate": "2016-01-21T21:27:02.425Z",
    "id": "555c7ba77aaceec91e3f2a01",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": []
  }, {
    "code": "G425120",
    "desc": "Leather clothing retailer",
    "definition": "<p>This includes retailing leatherwear.</p>",
    "definitionPlainText": "This includes retailing leatherwear.",
    "important": "",
    "lastUpdateDate": "2016-04-08T00:41:00.693Z",
    "id": "555c7ba77aaceec91e3f2a03",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Wholesaling leather clothing use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2954",
        "type": "bic",
        "desc": "F371210 Clothing wholesaling"
      }],
      "id": "55775f5c2c8535844998d7c2",
      "bicId": "555c7ba77aaceec91e3f2a03",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G424160",
    "desc": "Sporting equipment retailing - except clothing or footwear",
    "definition": "<p>This includes retailing sporting equipment eg fishing tackle, shooting and hunting equipment, equestrian equipment, golf equipment, snow skis, sailboards, canoes. </p><p>Also includes retailing playground equipment. Excludes retailing sporting clothing or footwear.</p>",
    "definitionPlainText": "This includes retailing sporting equipment eg fishing tackle, shooting and hunting equipment, equestrian equipment, golf equipment, snow skis, sailboards, canoes. Also includes retailing playground equipment. Excludes retailing sporting clothing or footwear.",
    "important": "",
    "lastUpdateDate": "2017-03-30T01:47:24.794Z",
    "id": "555c7ba77aaceec91e3f29ee",
    "cuId": "555b1da725a9732ca20a1302",
    "anzsicId": "555b206c25a9732ca20a1433",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1451",
    "cu": {
      "code": "52410",
      "desc": "Sport and camping equipment retailing",
      "id": "555b1da725a9732ca20a1302"
    },
    "anzsic": {
      "code": "G424100",
      "desc": "Sport and Camping Equipment Retailing",
      "id": "555b206c25a9732ca20a1433"
    },
    "bicrefs": [{
      "desc": "Retailing sports clothing use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2a02",
        "type": "bic",
        "desc": "G425115 Clothing retailing"
      }],
      "id": "557753b32c8535844998d764",
      "bicId": "555c7ba77aaceec91e3f29ee",
      "allRefsFoundDesc": true
    }, {
      "desc": "Retailing sports footwear use #$0",
      "order": 1,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2a0a",
        "type": "bic",
        "desc": "G425210 Footwear retailing"
      }],
      "id": "557753b32c8535844998d765",
      "bicId": "555c7ba77aaceec91e3f29ee",
      "allRefsFoundDesc": true
    }, {
      "desc": "Wholesaling sporting equipment (except clothing or footwear) use #$0",
      "order": 2,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f296f",
        "type": "bic",
        "desc": "F373450 Sporting good wholesaling - except clothing or footwear"
      }],
      "id": "557753b32c8535844998d766",
      "bicId": "555c7ba77aaceec91e3f29ee",
      "allRefsFoundDesc": true
    }, {
      "desc": "Wholesaling playground equipment use #$0",
      "order": 3,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f296d",
        "type": "bic",
        "desc": "F373430 Playground equipment wholesaling"
      }],
      "id": "557753b32c8535844998d767",
      "bicId": "555c7ba77aaceec91e3f29ee",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G425105",
    "desc": "Baby wear retailing",
    "keywords": ["babywear"],
    "definition": "<p>This includes retailing baby clothing.</p>",
    "definitionPlainText": "This includes retailing baby clothing.",
    "important": "",
    "lastUpdateDate": "2015-11-03T23:07:56.990Z",
    "id": "555c7ba77aaceec91e3f2a00",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Wholesaling baby clothing use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2954",
        "type": "bic",
        "desc": "F371210 Clothing wholesaling"
      }],
      "id": "55775f432c8535844998d7c0",
      "bicId": "555c7ba77aaceec91e3f2a00",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G425125",
    "desc": "Lingerie retailing",
    "keywords": [],
    "definition": "<p>This includes retailing underwear.</p>",
    "definitionPlainText": "This includes retailing underwear.",
    "important": "",
    "lastUpdateDate": "2015-11-03T23:08:23.209Z",
    "id": "555c7ba77aaceec91e3f2a04",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Wholesaling lingerie use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2954",
        "type": "bic",
        "desc": "F371210 Clothing wholesaling"
      }],
      "id": "55775f682c8535844998d7c3",
      "bicId": "555c7ba77aaceec91e3f2a04",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G425130",
    "desc": "Menswear retailing",
    "definition": "<p>This includes retailing mens and boys clothing.</p>",
    "definitionPlainText": "This includes retailing mens and boys clothing.",
    "important": "",
    "lastUpdateDate": "2015-11-03T23:10:05.819Z",
    "id": "555c7ba77aaceec91e3f2a05",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Wholesaling menswear use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2954",
        "type": "bic",
        "desc": "F371210 Clothing wholesaling"
      }],
      "id": "55775f742c8535844998d7c4",
      "bicId": "555c7ba77aaceec91e3f2a05",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G425135",
    "desc": "Millinery retailing",
    "definition": "<p>This includes retailing millinery.</p>",
    "definitionPlainText": "This includes retailing millinery.",
    "important": "",
    "lastUpdateDate": "2015-12-20T19:45:31.661Z",
    "id": "555c7ba77aaceec91e3f2a06",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "55624ea8f0529345d1e61d82",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Wholesaling millinery use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2954",
        "type": "bic",
        "desc": "F371210 Clothing wholesaling"
      }],
      "id": "55775f842c8535844998d7c5",
      "bicId": "555c7ba77aaceec91e3f2a06",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G425145",
    "desc": "Womenswear retailing",
    "definition": "<p>This includes retailing womens and girls clothing.</p>",
    "definitionPlainText": "This includes retailing womens and girls clothing.",
    "important": "",
    "lastUpdateDate": "2015-11-03T23:09:58.908Z",
    "id": "555c7ba77aaceec91e3f2a08",
    "cuId": "555b1da725a9732ca20a1291",
    "anzsicId": "555b206c25a9732ca20a1072",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1075",
    "cu": {
      "code": "52210",
      "desc": "Clothing retailing",
      "id": "555b1da725a9732ca20a1291"
    },
    "anzsic": {
      "code": "G425100",
      "desc": "Clothing Retailing",
      "id": "555b206c25a9732ca20a1072"
    },
    "bicrefs": [{
      "desc": "Wholesaling womenswear use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2954",
        "type": "bic",
        "desc": "F371210 Clothing wholesaling"
      }],
      "id": "55775f982c8535844998d7c7",
      "bicId": "555c7ba77aaceec91e3f2a08",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G426010",
    "desc": "Department store operation",
    "definition": "<p>This only includes businesses retailing a wide variety of goods (other than food or groceries) and have retail sales in at least 4 of the following product groups: clothing, furniture, kitchenware, china, glassware, other housewares, textile goods, electrical, electronic and gas appliances, perfumes, cosmetics, and toiletries. These products are normally displayed in different departments, and supporting functions (eg administration and accounting) are undertaken on a departmentalised basis.</p>",
    "definitionPlainText": "This only includes businesses retailing a wide variety of goods (other than food or groceries) and have retail sales in at least 4 of the following product groups: clothing, furniture, kitchenware, china, glassware, other housewares, textile goods, electrical, electronic and gas appliances, perfumes, cosmetics, and toiletries. These products are normally displayed in different departments, and supporting functions (eg administration and accounting) are undertaken on a departmentalised basis.",
    "important": "",
    "lastUpdateDate": "2015-06-09T21:47:05.951Z",
    "id": "555c7ba77aaceec91e3f2a14",
    "cuId": "555b1da725a9732ca20a1290",
    "anzsicId": "555b206c25a9732ca20a1104",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1111",
    "cu": {
      "code": "52100",
      "desc": "Department stores",
      "id": "555b1da725a9732ca20a1290"
    },
    "anzsic": {
      "code": "G426000",
      "desc": "Department Stores",
      "id": "555b206c25a9732ca20a1104"
    },
    "bicrefs": [{
      "desc": "Retailing food and groceries on a departmentalised basis use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2999",
        "type": "bic",
        "desc": "G411020 General store operation - mainly grocery"
      }],
      "id": "55775ed92c8535844998d7bc",
      "bicId": "555c7ba77aaceec91e3f2a14",
      "allRefsFoundDesc": true
    }, {
      "desc": "Supermarkets use #$0",
      "order": 1,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f299b",
        "type": "bic",
        "desc": "G411040 Grocery supermarket operation"
      }],
      "id": "55775ed92c8535844998d7bd",
      "bicId": "555c7ba77aaceec91e3f2a14",
      "allRefsFoundDesc": true
    }, {
      "desc": "Dairies use #$0",
      "order": 2,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2998",
        "type": "bic",
        "desc": "G411010 Dairy/superette operation"
      }],
      "id": "55775ed92c8535844998d7be",
      "bicId": "555c7ba77aaceec91e3f2a14",
      "allRefsFoundDesc": true
    }, {
      "desc": "Retailing a variety of goods not on a departmentalised basis use #$0",
      "order": 3,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2a33",
        "type": "bic",
        "desc": "G427937 General store operation - other than mainly grocery"
      }],
      "id": "55775ed92c8535844998d7bf",
      "bicId": "555c7ba77aaceec91e3f2a14",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "G425920",
    "desc": "Leather good retailing - except apparel",
    "definition": "<p>This excludes retailing leather clothing and footwear.</p>",
    "definitionPlainText": "This excludes retailing leather clothing and footwear.",
    "important": "",
    "lastUpdateDate": "2015-11-03T23:18:31.116Z",
    "id": "555c7ba77aaceec91e3f2a0f",
    "cuId": "555b1da725a9732ca20a1312",
    "anzsicId": "555b206c25a9732ca20a1317",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1330",
    "cu": {
      "code": "52560",
      "desc": "Personal accessories retailing (not elsewhere classified)",
      "id": "555b1da725a9732ca20a1312"
    },
    "anzsic": {
      "code": "G425900",
      "desc": "Other Personal Accessories Retailing",
      "id": "555b206c25a9732ca20a1317"
    },
    "bicrefs": [{
      "desc": "Retailing leather clothing use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2a03",
        "type": "bic",
        "desc": "G425120 Leather clothing retailer"
      }],
      "id": "557760882c8535844998d7cb",
      "bicId": "555c7ba77aaceec91e3f2a0f",
      "allRefsFoundDesc": true
    }, {
      "desc": "Retailing leather footwear use #$0",
      "order": 1,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2a0a",
        "type": "bic",
        "desc": "G425210 Footwear retailing"
      }],
      "id": "557760882c8535844998d7cc",
      "bicId": "555c7ba77aaceec91e3f2a0f",
      "allRefsFoundDesc": true
    }]
  }],
  "helpForSearchTerm": "<p><b>Please note:</b></p><p>Message</p>"
}